const Users = [
    {
      id: 1,
      username: 'johndoe',
      wallet_address: '0x1234567890abcdef',
      profile_image: 'https://via.placeholder.com/150'
    },
    {
      id: 2,
      username: 'janedoe',
      wallet_address: '0x0987654321fedcba',
      profile_image: 'https://via.placeholder.com/150'
    },
    {
      id: 3,
      username: 'jimmy',
      wallet_address: '0xabcdef0987654321',
      profile_image: 'https://via.placeholder.com/150'
    }
  ];
  
  export default Users;